import { render, staticRenderFns } from "./NewDataType.vue?vue&type=template&id=8a9fb9b8&scoped=true"
import script from "./NewDataType.vue?vue&type=script&lang=js"
export * from "./NewDataType.vue?vue&type=script&lang=js"
import style0 from "./NewDataType.vue?vue&type=style&index=0&id=8a9fb9b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a9fb9b8",
  null
  
)

export default component.exports